<template>
  <div v-if="url" class="h-full">
    <ResponsiveImage
      v-if="__typename === 'MediaImage'"
      :url="url"
      :alt="alt"
      :title="title"
      :hash="hash"
      :responsive-style="responsiveStyle"
      :no-lazy-loading="noLazyLoading"
      :image-class="imageClass"
      :no-draggable="noDraggable"
    />
    <CantoImage
      v-if="__typename === 'MediaCanto'"
      :alt="alt"
      :title="title"
      :render-url="renderUrl"
      :responsive-style="responsiveStyle"
      :aspect-ratio="aspectRatio"
      :crop-alignment="cropAlignment"
      :fit="fit"
      :no-lazy-loading="noLazyLoading"
      :image-class="imageClass"
      :no-draggable="noDraggable"
    />
  </div>
</template>

<script lang="ts" setup>
import type {
  MediaImageFragment,
  MediaCantoFragment,
} from '#graphql-operations'
import type { ResponsiveStyleName } from '~/helpers/responsiveStyles'
import type { ClassProp } from '~/types/vue'
import type { CantoCropAlignment } from '~/helpers/canto'

const props = withDefaults(
  defineProps<{
    __typename?: string
    mid?: string
    changed?: string
    responsiveStyle?: ResponsiveStyleName
    /** Optional crop aspect ratio (width / height) for Canto images. */
    aspectRatio?: number
    /** Canto smart-crop placement. Ignored for Drupal images. */
    cropAlignment?: CantoCropAlignment
    /** Canto URL fit. `scale` lets CSS object-position pan the original. */
    fit?: 'crop' | 'scale'
    noLazyLoading?: boolean
    noDraggable?: boolean
    fileUrl?: MediaImageFragment['fileUrl']
    image?: MediaImageFragment['image']
    imageClass?: ClassProp

    assetId?: MediaCantoFragment['assetId']
    renderUrl?: MediaCantoFragment['renderUrl']
    titleCanto?: MediaCantoFragment['titleCanto']
    altCanto?: MediaCantoFragment['altCanto']
  }>(),
  {
    __typename: 'MediaImage',
    media: undefined,
    mid: '',
    fileUrl: undefined,
    assetId: '',
    renderUrl: '',
    image: undefined,
    changed: '',
    responsiveStyle: 'column_full',
    aspectRatio: undefined,
    cropAlignment: undefined,
    fit: 'crop',
    noLazyLoading: false,
    imageClass: undefined,
    noDraggable: false,
    titleCanto: '',
    altCanto: '',
  },
)
const url = computed(() => props.fileUrl?.path || props?.renderUrl)

const alt = computed(() => props.image?.alt || props?.altCanto)

const title = computed(() => props.image?.title || props?.titleCanto)

const hash = computed(() => props.changed || '')
</script>
